import Vue from 'vue'

// import { BootstrapVue } from 'bootstrap-vue'
import { CardPlugin, ListGroupPlugin } from 'bootstrap-vue';

import '../assets/scss/custom.scss';


// Vue.use(BootstrapVue)
Vue.use(CardPlugin)
Vue.use(ListGroupPlugin)
